<template>
   <el-config-provider :locale="locale">
    <div class="app">
    <router-view />
  </div>
  </el-config-provider>
 
</template>
<script lang="ts">
  import { ElConfigProvider } from 'element-plus'
  import zhCn from 'element-plus/lib/locale/lang/zh-cn'

  export default {
    components: {
      [ElConfigProvider.name]: ElConfigProvider
    },
    setup() {
      
      // 切换为中文
      let locale = zhCn

      return {
        locale
      }
      
    }
  }
</script>
<style lang="scss" scoped>
.app{
 
 
}
</style>
